module.exports = __webpack_public_path__ + "static/media/USYGY100080.576bd340.jpg";